import React from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import 'react-vertical-timeline-component/style.min.css';
import { PersistGate } from 'redux-persist/integration/react';
import App from '@/containers/App';
import '@/styles/styles.scss';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { persistor, store } from './store';

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById('root'),
);

// Registers for service worker
serviceWorkerRegistration.register();
